import { COLOR_PALETTE } from '../../data/mockTemplates';

/**
 * Reusable color-swatch picker. `value` is a hex string or null
 * (unset — used by EventFormSheet, whose color starts as "設定なし"
 * until the user taps a swatch or picks a template). Used by both
 * EventFormSheet and TemplateEditorSheet.
 */
export default function ColorRow({ value, onChange }) {
  return (
    <div className="color-row">
      {COLOR_PALETTE.map((c) => (
        <div
          key={c}
          className={`color-dot${value && value.toLowerCase() === c.toLowerCase() ? ' selected' : ''}`}
          style={{ background: c }}
          onClick={() => onChange(c)}
        />
      ))}
    </div>
  );
}
